import { toString } from 'lodash';
import url from 'url';

import { ACTION_PREFIX } from '../../constants';
import popularCarriersSelector from './popularCarriersSelector';
import popularBcbsCarriersSelector from './popularBcbsCarriersSelector';
import { insuranceTypeSelector } from '../insurance-type';

export const REQUEST_POPULAR_CARRIERS = `${ACTION_PREFIX}/REQUEST_POPULAR_CARRIERS`;
export const REQUEST_POPULAR_CARRIERS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_POPULAR_CARRIERS_SUCCEEDED`;
export const REQUEST_POPULAR_BCBS_CARRIERS = `${ACTION_PREFIX}/REQUEST_BCBS_POPULAR_CARRIERS`;
export const REQUEST_POPULAR_BCBS_CARRIERS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_POPULAR_BCBS_CARRIERS_SUCCEEDED`;

const apiUrl = url.parse(process.env.API_HOST || '');

function requestPopularCarriers(insuranceType, isBcbs) {
    return {
        type: isBcbs ? REQUEST_POPULAR_BCBS_CARRIERS : REQUEST_POPULAR_CARRIERS,
        payload: {
            insuranceType,
        },
    };
}

function requestPopularCarriersSucceeded(insuranceType, carriers, isBcbs) {
    return {
        type: isBcbs ? REQUEST_POPULAR_BCBS_CARRIERS_SUCCEEDED : REQUEST_POPULAR_CARRIERS_SUCCEEDED,
        payload: {
            insuranceType,
            carriers: carriers.map(([carrierId, ...rest]) => [toString(carrierId), ...rest]),
        },
    };
}

function fetchPopularCarriers(state, isBcbs, directoryId) {
    return dispatch => {
        const insuranceType = insuranceTypeSelector(state);
        dispatch(requestPopularCarriers(insuranceType, isBcbs));
        return fetch(url.format({
            protocol: apiUrl.protocol,
            host: apiUrl.host,
            pathname: '/api/1/carriers',
            query: {
                type: insuranceType,
                tier: 1,
                parent: isBcbs ? 304 : '',
                directoryType: directoryId === '572' ? 'insurance,geisingerhealthplan' : null,
            },
        }), {
            credentials: 'same-origin',
        })
            .then(response => response.json())
            .then(json => dispatch(requestPopularCarriersSucceeded(insuranceType, json.carriers, isBcbs)))
        // eslint-disable-next-line no-console
            .catch(err => console.error(err));
    };
}

function shouldFetchPopularCarriers(state) {
    const carriers = popularCarriersSelector(state);
    if (!carriers) {
        return true;
    }
    return false;
}

export function fetchPopularCarriersIfNeeded(directoryId) {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchPopularCarriers(state)) {
            return dispatch(fetchPopularCarriers(state, false, directoryId));
        }
    };
}

function shouldFetchPopularBcbs(state) {
    const carriers = popularBcbsCarriersSelector(state);
    if (!carriers) {
        return true;
    }
    return false;
}

export function fetchPopularBcbsCarriersIfNeeded() {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchPopularBcbs(state)) {
            return dispatch(fetchPopularCarriers(state, true));
        }
    };
}
